import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';
/*
생성/등록/추가 : create
삭제/제거 : delete
편집/수정 : update
상세페이지/보기 : read
리스트/보기 : readList
엑셀다운로드 : downloadExcel
*/
export const TAG_MENU: PermissionTableRowType = {
  name: '태그',
  key: 'TAG_MANAGE',
  subRows: [
    {
      name: '태그 관리',
      key: PERMISSION_SUBJECTS.TAG,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.READ,
        PERMISSION_ACTIONS.CREATE,
        PERMISSION_ACTIONS.UPDATE,
      ],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.TAG,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '태그 상세 조회',
          key: PERMISSION_SUBJECTS.TAG,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '태그 등록',
          key: PERMISSION_SUBJECTS.TAG,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
        {
          name: '태그 편집',
          key: PERMISSION_SUBJECTS.TAG,
          permissions: [PERMISSION_ACTIONS.UPDATE],
        },
      ],
    },
    {
      name: '태그그룹 관리',
      key: PERMISSION_SUBJECTS.TAG_GROUP,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.READ,
        PERMISSION_ACTIONS.CREATE,
        PERMISSION_ACTIONS.UPDATE,
      ],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.TAG_GROUP,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '태그그룹 등록',
          key: PERMISSION_SUBJECTS.TAG_GROUP,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
        {
          name: '태그그룹 편집',
          key: PERMISSION_SUBJECTS.TAG_GROUP,
          permissions: [PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.UPDATE],
        },
      ],
    },
    {
      name: '태그 메인 탭 관리',
      key: PERMISSION_SUBJECTS.TAG_TAB_MAIN,
      permissions: [PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.UPDATE],
    },
    {
      name: '태그 트렌드 키워드 관리',
      key: PERMISSION_SUBJECTS.TAG_TREND_KEYWORD,
      permissions: [PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.UPDATE],
    },
  ],
};
